import React, { useEffect, useMemo } from 'react'
import { ChevronLeft as ChevronLeftIcon } from 'react-feather'
import {
  makeStyles, Card, CardContent, Typography, Grid, Button, Divider,
} from '@material-ui/core'
import {
  useParams, useLocation, useNavigate, Link,
} from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import moment from 'moment-jalaali'
import PropTypes from 'prop-types'
import { useOneTime } from '../../hooks'
import { deleteComments, getComments } from '../../app/slices/commentSlice'
import Chat from './ChatBox'
import {
  //  getUserDetailsById,
  selectorUserDetails,
} from '../../app/slices/userSlice'

const STATUS = {
  100: 'در حال بررسی',
  110: 'پاسخ داده شده',
}

const useStyle = makeStyles(() => ({
  root: {
    padding: 10,
    borderRadius: '20px',
  },
  header: {
    flexWrap: 'nowrap',
  },
  marginBottom: {
    marginBottom: 10,
  },
  title: {
    fontWeight: 700,
    marginRight: 20,
    '& > span': {
      fontWeight: 400,
    },
  },
  chatsTitle: {
    fontWeight: 700,
    marginTop: 30,
  },
  titleName: {
    '& > span': {
      marginLeft: 10,
    },
  },
  status0: {
    color: '#009fff',
  },
  status1: {
    color: '#ff008c',
  },
  status2: {
    color: '#25d423',
  },
  status3: {
    color: '#00000059',
  },
  cardContent: {
    padding: 0,
    paddingBottom: '0px !important',
  },

}))

export const ChatPage = ({ isUser = false }) => {
  const classes = useStyle()
  const { user, comments } = useSelector((state) => state)
  const userDetails = useSelector(selectorUserDetails)
  const { ticketId } = useParams()
  const dispatch = useDispatch()
  const selectedTicket = useLocation()?.state
  const navigate = useNavigate()
  // const user = useSelector((state) => state.user)

  console.log(user?.userProfile?.photo?.url)
  console.log(user?.userId)
  console.log(comments?.[0]?.file?.userId)
  console.log(comments?.[0]?.file?.userId === user?.userId)
  console.log(userDetails)

  useOneTime(() => {
    if (!selectedTicket) navigate('..')
  })

  // this hook will check if the ticket info isn't in the location state it will
  // redirect user to tickt list so user can renew the state by clicking on one
  // of the tickets
  useOneTime(() => {
    dispatch(getComments(ticketId))
    // dispatch(getUserDetailsById(ticketId))
  })

  useEffect(() => () => {
    dispatch(deleteComments())
    // dispatch(getUserProfileInfo())
  }, [dispatch])

  // let userImage = null
  // if()

  const craeteDate = useMemo(() => {
    const date = moment(selectedTicket?.createDate)
    return date.format('jYYYY/jMM/jDD')
  }, [selectedTicket?.craeteDate])

  return (
    <Card className={classes.root}>
      <CardContent className={classes.cardContent}>
        <Grid container className={`${classes.header} ${classes.marginBottom}`} justify="space-between" alignItems="center">
          <Grid container>
            <Typography variant="h4" className={classes.title}>
              عنوان مکالمه:&nbsp;
              <span>{selectedTicket?.question}</span>
            </Typography>
            <Typography>
              تاریخ ایجاد:&nbsp;
              <span>{craeteDate}</span>
            </Typography>
          </Grid>
          <Link to="..">
            <Button color="primary">
              <span>بازگشت</span>
              <ChevronLeftIcon />
            </Button>
          </Link>
        </Grid>
        <Grid container className={`${classes.marginBottom}`}>
          <Typography className={classes.titleName}>
            فرستنده:
            <span>{selectedTicket?.owner?.userName}</span>
          </Typography>
        </Grid>
        <Grid container className={`${classes.marginBottom}`}>
          <Typography className={classes.titleName}>
            شماره تماس:
            <span>{selectedTicket?.owner?.profile?.phoneNumber}</span>
          </Typography>
        </Grid>
        <Grid container className={`${classes.marginBottom}`}>
          <Typography className={classes.titleName}>
            وضعیت:
            <span className={classes[`status${selectedTicket?.status}`]}>{STATUS[selectedTicket?.status]}</span>
          </Typography>
        </Grid>
        <Divider />

        <Grid container className={`${classes.marginBottom}`}>
          <Typography variant="h4" className={classes.chatsTitle}>مکالمات</Typography>
        </Grid>
        <Chat
          isUser={isUser}
          selectedTicket={selectedTicket}
          showInput={selectedTicket?.status !== 3}
          chat={comments}
          id={user.id || user.userId || 1}
          // userPhoto={comments?.[0]?.file?.userId
          //  === user?.userId && user?.userProfile?.photo?.url}
          userPhoto={user?.userProfile?.photo?.url}
        />
      </CardContent>
    </Card>
  )
}

ChatPage.propTypes = {
  isUser: PropTypes.bool,
}

export default ChatPage
